<template lang="pug">
  .view-site-lessons-read
    .content(v-if="lesson")
      .columns
        presentation.column(v-if="presentation" :presentation="presentation")
          template(v-slot:controls)
            ui-button(icon="message" @click="toggleMessages")
        messaging.column(v-if="room" :room="room")
</template>

<script>
import api from '@/api';
import Lesson from '@/models/Lesson';
import Room from '@/models/Room';

export default {
  name: 'view-site-lessons-read',

  data: () => ({
    lesson: new Lesson(),
    presentation: null,
    room: null,
  }),

  watch: {
    $route: 'fetchData',
  },

  methods: {
    async fetchData() {
      await this.lesson.$find(this.$route.params.id, { include: 'presentations.slides' });

      if (this.lesson.presentations.count() > 0) {
        this.presentation = this.lesson.presentations.first();
      }
    },

    async toggleMessages() {
      if (this.room) {
        this.room = null;

        return;
      }

      const response = await api.for(`presentations/${this.presentation.id}/room`).fetch();

      this.room = new Room(response.data);
    },
  },

  created() {
    this.fetchData();
  },
};
</script>
